import React from "react"
import { FIOC_UPDATE_ACCOUNT_HIRING, DNI_UPDATE_ACCOUNT_HIRING } from 'constants/flagBasedFeatures.js'

import { taggingCancelEvent, taggingCloseEvent, taggingOpenEvent, taggingUpdateEvent } from "./helpers/taggings"
import { POE_KEY, REDIRECT_TO_UPDATE_DOCUMENT_ID_URL, REDIRECT_TO_UPDATE_FIOC_URL } from "./constants/fiocConfig"

export const useFiocStatus = ({ immFlagBasedFeatures, fiocStatus, closeRedirectURL, history }) => {
    const [openModal, setOpenModal ] = React.useState(false)
    const [isDocumentationRequired, setIsDocumentationRequired] = React.useState(false)


    React.useEffect(() => {
        const { documentationRequested, fiocRequested } = fiocStatus.toJS()
        const isAllowedFiocUpdateAccountHiring = immFlagBasedFeatures.get(FIOC_UPDATE_ACCOUNT_HIRING)
        const isAllowedDNIUpdateAccountHiring = immFlagBasedFeatures.get(DNI_UPDATE_ACCOUNT_HIRING)

        const displayFioc = isAllowedFiocUpdateAccountHiring && fiocRequested
        const displayDNI = isAllowedDNIUpdateAccountHiring && documentationRequested
        const isRequiredOnlyID = !displayFioc && displayDNI
        const showModal = displayFioc || displayDNI
    
        setIsDocumentationRequired(isRequiredOnlyID)
        setOpenModal(showModal)

        if (showModal) {
            taggingOpenEvent(isRequiredOnlyID)
        }
    }, [fiocStatus])

    const closeModal = (isCancel) => {
        isCancel
            ? taggingCancelEvent(isDocumentationRequired)
            : taggingCloseEvent(isDocumentationRequired)

        history.push(closeRedirectURL)
    }

    const redirectToUpdateFioc = () => {
        taggingUpdateEvent(isDocumentationRequired)
        const redirectUrl = isDocumentationRequired
            ? REDIRECT_TO_UPDATE_DOCUMENT_ID_URL
            : REDIRECT_TO_UPDATE_FIOC_URL

        history.push(redirectUrl)
    }

    const getPOEKeys = (contractIndex) => {
        const { description, documentationDescription, title } = POE_KEY[contractIndex]
        return {
            title,
            description: isDocumentationRequired
                ? documentationDescription
                : description
        }
    }

    return { openModal, closeModal, redirectToUpdateFioc, getPOEKeys }
}
